import { createSlice } from '@reduxjs/toolkit';

const startPageSlice = createSlice({
    name: 'startPage',
    initialState: {},
    reducers: {
        requestConfig: state => {
            state.isFetching = true;
        },
        receiveConfig: (state, { payload }) => {
            if (payload) {
                state.config = { ...payload };
            } else {
                state.config = null;
            }
            state.isFetching = false;
            state.hasResult = true;
        },
        receiveTrendingTags: (state, { payload }) => {
            state.trendingBrands =
                payload?.trendingBrands?.sort(sortByIndex) || [];
            state.trendingSearches =
                payload?.trendingSearches?.sort(sortByIndex) || [];
        }
    }
});

const sortByIndex = (a, b) => {
    if (a.index > b.index) return 1;
    if (a.index < b.index) return -1;
    return 0;
};

export const {
    requestConfig,
    receiveConfig,
    receiveTrendingTags
} = startPageSlice.actions;

export default startPageSlice.reducer;
